import BaseApi from './baseApi';
import IDataTable from '@/store/models/IDataTable';
import IAuthentication from '../models/IAuthentication';
import { StringObjectTuple } from '../types/types';
import { StringObjectArrayListTuple } from '@/store/types/types';

interface DataTableResponse {
    TableName: string;
    Columns: { ColumnName: string }[];
    Rows: { ItemArray: any[] }[];
}

export default class DataAcessApi extends BaseApi {
    idUser : string = "";

    constructor(FormId : string) {
        super("dataaccess", FormId);
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.id;
    }

    async ExecStructuredProcedure(spName: string, parameters: StringObjectTuple[], structures: StringObjectArrayListTuple[]) : Promise<IDataTable> {
        let json : string = this.getJsonExecStructuredProcedure(spName, parameters, structures);
        const response = await this.api.post('ExecStructuredProcedure', json);

        let result: IDataTable = {
            columns: [],
            records: []
        };

        if (response && response.isSuccess) {
            const dataTable = response.data as any[];
            if (dataTable.length > 0) {
                result.columns = Object.keys(dataTable[0]);
                result.records = dataTable;
            }
        }
        
        return result;
    }

    private getJsonExecStructuredProcedure(spName: string, parameters: StringObjectTuple[], structures: StringObjectArrayListTuple[]) : any {
        const mappedParameters = parameters.map(param => {
            return {
                Item1: param[0],
                Item2: param[1]
            };
        });
    
        // Mapear las estructuras al formato esperado por el servicio web
        const mappedStructures = structures.map(structure => {
            return {
                Item1: structure[0],
                Item2: structure[1]
            };
        });
    
        // Construir el objeto final
        const structuredParameters = {
            spName: spName,
            parameters: mappedParameters,
            structures: mappedStructures
        };
    
        return structuredParameters;
    }
}
